import { CreateButton, useResourceDefinition } from "react-admin";
import { useLocation } from "react-router-dom";

export const MyCreateButton = ({
  customResourceData = null,
  state = {},
  ...props
}) => {
  const location = useLocation();
  const contextResourceData = useResourceDefinition();
  const resourceData = customResourceData || contextResourceData;

  if (!resourceData.hasCreate) return null;

  state = { redirectTo: location.pathname + location.search, ...state };

  return <CreateButton state={state} {...props} />;
};
